module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget",
    attrs: {
      "id": "wid-id-5",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "data-widget-sortable": "false"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "widget-body"
  }, [_c('div', {
    staticClass: "tabs-left"
  }, [_c('ul', {
    staticClass: "nav nav-tabs tabs-left",
    attrs: {
      "id": "demo-pill-nav"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('li', [_vm._m(5)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-md-9"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab-r1"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nome Relatório")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "accept": "application/msword",
      "type": "file"
    },
    on: {
      "change": _vm.setModel
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Área")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ENTRADA"
    }
  }, [_vm._v("ENTRADA DE VEÍCULOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SAIDA"
    }
  }, [_vm._v("SAÍDA DE VEÍCULOS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveTemplate($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                        Salvar\n                      ")])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hovered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.templates), function(template) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "accept": "application/msword",
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.upload($event, template.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.seeTemplate(template.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle fa-lg"
    }), _vm._v(" Ver modelo atual\n                        ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTemplate(template.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-lg"
    }), _vm._v(" Apagar Modelo\n                        ")])])])
  }), 0), _vm._v(" "), _c('tfoot')])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-r2"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("ENTRADA")]), _vm._v(" "), _c('td', [_c('ul', [_vm._l((_vm.macros.entrada), function(value, macro) {
    return _c('li', [_vm._v(_vm._s(macro) + " - "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Ex: " + _vm._s(value))])])
  }), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_NOME")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CPF_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_IE_RG")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_DATA_NASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CELULAR")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CEP")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NOME")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MARCA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MODELO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANOFABRICACAO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_COR")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_KM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CAMBIO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NUMEROPORTAS")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_RENAVAM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_PLACA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CHASSI")])], 2)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SAÍDA")]), _vm._v(" "), _c('td', [_c('ul', [_vm._l((_vm.macros.saida), function(value, macro) {
    return _c('li', [_vm._v(_vm._s(macro) + " - "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Ex: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(value)
      }
    })])])
  }), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_NOME")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CPF_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_IE_RG")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_DATA_NASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CELULAR")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CEP")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NOME")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MARCA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MODELO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANOFABRICACAO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_COR")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_KM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CAMBIO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NUMEROPORTAS")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_RENAVAM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_PLACA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CHASSI")]), _vm._v(" "), _c('li', [_vm._v("VENDA_PRECO")]), _vm._v(" "), _c('li', [_vm._v("VENDA_DESCONTO")]), _vm._v(" "), _c('li', [_vm._v("VENDA_DATA")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOME")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CPF")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NATURALIDADE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_RG")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_RGDATAEXPEDICAO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADOEXPEDICAO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_DATANASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_SEXO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADOCIVIL")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CNH")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOMEPAI")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOMEMAE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CEP")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CELULAR")])], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-r4"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Taxa de Imposto (EX: 3%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_rate),
      expression: "icms_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" Base Tax ST Reduction EX: (Ex: 10%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_basetax_st_reduction),
      expression: "icms_basetax_st_reduction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_basetax_st_reduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_basetax_st_reduction = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ICMS Base Tax Modality (Ex: 1)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_basetax_modality),
      expression: "icms_basetax_modality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_basetax_modality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_basetax_modality = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("ICMS CST (Ex: 3)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_cst),
      expression: "icms_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_cst = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" Origem ICMS (Ex: 9)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_origin),
      expression: "icms_origin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_origin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_origin = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("  PIS rate (Ex: 6,50%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pis_rate),
      expression: "pis_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pis_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pis_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("PIS CST (Ex: 12)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pis_cst),
      expression: "pis_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pis_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pis_cst = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("  COFINS rate (Ex: 12.50%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cofins_rate),
      expression: "cofins_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cofins_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cofins_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("COFINS CST (Ex: 1)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cofins_cst),
      expression: "cofins_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cofins_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cofins_cst = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" \n    Configurações\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("Tabela de configurações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab-r1",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })]), _vm._v("\n                Relatórios\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab-r2",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" Macros")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab-r4",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })]), _vm._v(" NF-e ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab-r3",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-greenLight txt-color-white"
  }, [_vm._v("0")]), _vm._v(" Item 3")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("\n                        RELATÓRIO\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        ÁREA\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        MODELO\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        MODELO ATUAL\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ÁREA")]), _vm._v(" "), _c('th', [_vm._v("MACROS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe446ee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config.vue
// module id = 1080
// module chunks = 1